module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.926112b5.svg";